import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import { colorGrey50, componentSpacing04, componentSpacing08 } from '../../../tokens';
import { getComponentOverride, propsBlocker, spacing } from '../../../system';
import { Typography } from '../../Typography';
export var SideSheetHeaderRoot = styled.div.withConfig(propsBlocker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    padding-bottom: ", ";\n    padding-right: ", ";\n    ", ";\n"])), spacing(componentSpacing08), spacing(componentSpacing04), getComponentOverride('SideSheetHeader'));
export var SideSheetHeaderTypography = styled(Typography)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-top: 0;\n    margin-bottom: ", ";\n    font-size: 1.5em;\n"])), spacing(2));
export var descriptionTypographyStyle = {
  color: colorGrey50,
  marginBottom: 0,
  marginTop: 0
};